import { Stack, useTheme } from '@mui/material';
import { memo } from 'react';
import useWidth from '../../../../../../../../../../components/Hooks/useWidth';
import Typography from '../../../../../../../../../../components/Typography/Typography';
import LangEnum from '../../../../../../../../../../lang/LangEnum';
import { SelloutProductColor } from '../../../../../../../../../../services/modules/product-color-sellout/product-color-sellout.types';
import { useTranslation } from '../../../../../../../../../translation/TranslationContext';
import SelloutModalContentDesktop from '../../desktop/components/SelloutModalContentDesktop';
import { SelloutDistribution } from '../../distribution/types/selloutDistribution.types';
import SelloutModalContentMobile from '../../mobile/components/SelloutModalContentMobile';

interface SelloutModalContentProps {
  selloutProductColor: SelloutProductColor;
  pieces: number;
  distribution: SelloutDistribution[];
  disabled: boolean;
  onChangePieces: (value: number) => void;
}

const SelloutModalContent = ({
  pieces,
  disabled,
  distribution,
  selloutProductColor,
  onChangePieces,
}: SelloutModalContentProps) => {
  const theme = useTheme();
  const { mobileWidth } = useWidth();
  const { translate } = useTranslation();
  const sizesQuantity = selloutProductColor.skus.length;

  const props: SelloutModalContentProps = {
    pieces,
    disabled,
    distribution,
    selloutProductColor,
    onChangePieces,
  };

  return (
    <Stack spacing="16px">
      <Typography
        color={theme.palette.grey[600]}
        maxWidth={sizesQuantity <= 5 ? '440px' : undefined}
      >
        {translate(LangEnum.ORDER_SELLOUT_MODAL_MAIN_DESCRIPTION)}
      </Typography>

      {mobileWidth ? (
        <SelloutModalContentMobile {...props} />
      ) : (
        <SelloutModalContentDesktop {...props} />
      )}
    </Stack>
  );
};

export default memo(SelloutModalContent);
